
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuyen-dung",
      function () {
        return require("private-next-pages/tuyen-dung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuyen-dung"])
      });
    }
  